import React, { useEffect, useState, Fragment } from "react";
import { getFlatFee, getPercentFee } from "data/entity";
import { useSelector, useDispatch } from "react-redux";
import { formValueSelector, autofill as formChange } from "redux-form";
import {
  updateAllocationAmount,
  getSelectedAllocations,
} from "data/giving-form/allocation-selection";
import { FormattedMessage, FormattedNumber } from "react-intl";

const CoverFee = ({ currencyCode, handleCheckedFee, totalAmount }) => {
  const dispatch = useDispatch();
  const flatFee = useSelector((state) => getFlatFee(state));
  const percentFee = useSelector((state) => getPercentFee(state));
  const [feeAmount, setFeeAmount] = useState(null);
  const [isCoverFee, setIsCoverFee] = useState(false);
  const selectedAllocations = useSelector((state) => getSelectedAllocations(state));

  useEffect(() => {
    if (flatFee < 0 || percentFee < 0 || (!flatFee && !percentFee)) {
      return;
    }

    setFeeAmount(calcFee(totalAmount));
  }, []);

  const calcFee = (amount) => {
    if (!amount) {
      return 0;
    }

    return parseFloat(((1 + percentFee) * amount + flatFee - amount).toFixed(2));
  };

  return (
    <Fragment>
      {feeAmount && (
        <h5
          style={{ cursor: "pointer" }}
          onClick={() => {
            setIsCoverFee(!isCoverFee);
            handleCheckedFee(!isCoverFee, feeAmount);
          }}>
          <input
            data-testid="t-CoverFe-checkbox"
            className="check_box"
            type="checkbox"
            checked={isCoverFee}
          />
          {` `}
          <FormattedMessage id="coverFee" />
          {` `}
          <FormattedNumber
            value={feeAmount}
            currencyDisplay="symbol"
            style="currency"
            currency={currencyCode}
          />
        </h5>
      )}
    </Fragment>
  );
};

export default CoverFee;
